import { PreferencesBasedThemeProvider } from "@react-admin/ra-preferences";
import { Admin } from 'react-admin';
import { Resource } from "@react-admin/ra-rbac";
import "./App.scss";
import Layout from "./common/app/Layout";
import { Loader } from "./common/components";
import CustomRoutes from "./CustomRoutes";
import authProvider from "./provider/auth/AuthProvider";
import { useHasura } from './provider/data/DataProvider';
import I18nProvider from "./provider/I18nProvider";
import { LotIcon, LotList } from "./views/Lot";
import { ProjectCreate, ProjectEdit, ProjectIcon, ProjectList } from "./views/Project";
import { TaskEdit, TaskIcon, TaskList } from './views/Task';
import { TeamCreate, TeamEdit, TeamIcon, TeamList } from "./views/Team";
import { UserCreate, UserEdit, UserIcon, UserList } from "./views/User";
import { WorkflowCreate, WorkflowEdit, WorkflowIcon, WorkflowList } from "./views/Workflow";
import { useEffect, useState } from "react";

const App = () => {
    const [init, setInit] = useState(false);
    const [token, setToken] = useState();
    const dataProvider = useHasura(token);
    useEffect(() => {
        authProvider.init(setToken).then(() => {
            setInit(true);
        }).catch(() => {
            setInit(true);
        });
    }, []);
    if (!dataProvider || !init) return <Loader />;
    return <PreferencesBasedThemeProvider>
        <Admin disableTelemetry authProvider={authProvider} customRoutes={CustomRoutes} dataProvider={dataProvider} i18nProvider={I18nProvider} layout={Layout}>
            <Resource name="task" list={TaskList} edit={TaskEdit} icon={TaskIcon} />
            <Resource name="project" list={ProjectList} edit={ProjectEdit} create={ProjectCreate} icon={ProjectIcon} />
            <Resource name="lot" list={LotList} icon={LotIcon} />
            <Resource name="team" list={TeamList} edit={TeamEdit} create={TeamCreate} icon={TeamIcon} />
            <Resource name="user" list={UserList} edit={UserEdit} create={UserCreate} icon={UserIcon} />
            <Resource name="workflow" list={WorkflowList} edit={WorkflowEdit} create={WorkflowCreate} icon={WorkflowIcon} />
            <Resource name="stage" />
            <Resource name="stage_infos" />
            <Resource name="production_unit" />
            <Resource name="team_member" />
            <Resource name="user_role" />
            <Resource name="ref_role" />
            <Resource name="file" />
            <Resource name="manager_starting" />
            <Resource name="project_delegate" />
            <Resource name="lot_time" />
        </Admin>
    </PreferencesBasedThemeProvider>
};

export default App;